<script setup>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import _ from 'lodash';
import axios from 'axios';
import { ref, onMounted, watchEffect, computed } from 'vue';
import { authHeader } from "../../helpers/authservice/auth-header";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import store from "../../state/store";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import moment from "moment";
import MediaViewer from "../../components/general-search/media-viewer.vue";
// import NovViewer from "../../components/general-search/nov-viewer.vue";
import Timeline from "../../components/general-search/timeline.vue";
import ViolationInformation from "../../components/general-search/traffic-record/violation-information.vue";
import LtoRecord from "../../components/general-search/traffic-record/lto-record.vue";
import Violations from "../../components/general-search/traffic-record/violations.vue";
// import Ovr from "../../components/general-search/ovr/ovr.vue";
// import ViolationPenaltyMatrix from "../../components/general-search/ovr/violation-penalty-matrix.vue";
// import Tracking from "../../components/general-search/tracking.vue";
// import Payment from "../../components/general-search/payment/payment.vue";
// import OrEditLogs from "../../components/general-search/payment/or-edit-logs.vue";
// import Apprehension from "../../components/general-search/apprehension.vue";
import Swal from 'sweetalert2';

const loading = computed(() => store.state.globals.loading);
const isSearch = ref(false);
const cameraResult  = ref(null);
const search = ref({
  camera_id: null,
  date: moment().format('DD/MM/YYYY'),
  from: '00:00',
  to: '23:59'
});

const filters = ref([]);
const cameras = ref([]);
const traffic_record_ids = ref([]);

const cameraFilterModalTab = ref(0);
const selectedCameraFilter = ref(null);
const selectedTrafficRecords = ref([]);
const reject_reason_list = computed(() => store.state.trafficRecordComponent.reject_reason_list);

const selected_reject_reason = computed({
  get:() => store.state.trafficRecordComponent.selected_reject_reason,
  set:(val) => store.commit('trafficRecordComponent/SET_SELECTED_REJECT_REASON',val)
});
const other_reject_reason = computed({
  get:() => store.state.trafficRecordComponent.other_reject_reason,
  set:(val) => store.commit('trafficRecordComponent/SET_OTHER_REJECT_REASON',val)
});

const getRejectReasonList = () => store.dispatch('trafficRecordComponent/getRejectReasonList');

const selectRejectReason = () => {
  other_reject_reason.value = '';
}

const setSelected = async () => {
    cameraResult.value = await cameras.value.find(camera => camera.camera_id === search.value.camera_id);
}

const getCameras = async (search) => {
  try {
    const { data } = await axios.get(`/cameras`, {
      headers: authHeader(),
      params: {
        search: search === '' ? '' : encodeURIComponent(search),
        pageSize: 3000
      }
    });

    return data.data;
  } catch (err) {
    console.log(err);
  }
}

const searchQuery =  _.debounce( async  (loading = false, search = '') => {
  const data = await getCameras(search);
  cameras.value = data;
  if (loading) {
    loading(false)
  }
}, 500)

const onSearch = (search, loading) => {
  if (search.length) {
    loading(true);
    searchQuery(loading, search);
  }
}

const title = ref("Camera Filter");
const items = ref([
  {
    text: "Home",
    href: "/"
  },
  {
    text: "Camera",
  },
  {
    text: "Filter",
    active: true,
  }
]);

const humanfriendlyConfig = ref({
  altInput: true,
  altFormat: "F j, Y",
  dateFormat: "d/m/Y"
});

const timePicker = ref({
  altInput: true,
  enableTime: true,
  noCalendar: true,
  altFormat: "h:i K",
  dateFormat: "H:i"
});

const clickSearch = async () => {
  if (!search.value.camera_id) return;

  store.dispatch('globals/loading', null, { root: true });
  filters.value = [];

  try {
    const { data } = await axios.get('/camera/filter', {
      params: { 
        ...search.value
      }
    })

    if (data.data.length) {
      filters.value = data.data;
      selectedTrafficRecords.value = [];
    }

    selected_reject_reason.value = null;
    traffic_record_ids.value = [];
    other_reject_reason.value = '';

    isSearch.value = true;
    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    isSearch.value = false;
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const getCameraFilterDetails = async (id) => {
  if (!id) return;

  store.dispatch('globals/loading', null, { root: true });

  try {
    const { data } = await axios.get('/camera/filter/modal/information', {
      params: {
        traffic_record_id: id
      },
      headers: authHeader()
    })

    selectedCameraFilter.value = data.data[Object.keys(data.data)[0]];

    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    const { message } = err.response.data;
    store.dispatch('globals/loaded', null, { root: true });
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message
    })
  }
}

const resetCameraFilterDetails = () => {
  cameraFilterModalTab.value = 0;
  selectedCameraFilter.value = null;
}

const toggleAll = async () => {
  if (traffic_record_ids.value.length == filters.value.length) {
    traffic_record_ids.value = []; 
    return;
  }

  if(filters.value.length){
    traffic_record_ids.value = []; 
    filters.value.forEach(function (filter){
      traffic_record_ids.value.push(filter.id)
    });
  }
} 

const toggleSelect = async (id) => {
    if(!traffic_record_ids.value.includes(id)){
      traffic_record_ids.value.push(id)
    } else {
      traffic_record_ids.value.splice(traffic_record_ids.value.indexOf(id),1)
    }
} 

const reject = async () => {
  if(!selected_reject_reason.value){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please select a reject reason.',
    })
  }

  if(selected_reject_reason.value && selected_reject_reason.value == 7 && !other_reject_reason.value){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please enter other reason.',
    })
  }

  if(!traffic_record_ids.value.length){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please select a traffic records.',
    })
  }

  const confirm = await Swal.fire({
      icon: 'info',
      title: 'Continue?',
      text: `Do you want to reject ${traffic_record_ids.value.length} traffic record(s)?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
  })

  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    const { data } = await axios.post('/camera/filter/reject', {
      traffic_record_ids: traffic_record_ids.value,
      reject_reason_id: selected_reject_reason.value,
      other_reject_reason: other_reject_reason.value
    }, {
      headers: authHeader()
    });

    console.log(data);
    await clickSearch();

    store.dispatch('globals/loaded', null, { root: true });
    Swal.fire("Success", `Successfully rejected!` , "success");
  } catch(err) {
    const { message } = err.response.data;
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message
    })
    store.dispatch('globals/loaded', null, { root: true });
  }
}

onMounted(async () => {
    await getRejectReasonList();
    const data = await getCameras('');
    cameras.value = data;
    selected_reject_reason.value = null;
});

watchEffect(()=>{
    if (search.value.camera_id) {
        setSelected();
    }
});
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex mb-4 justify-content-between">
      <div>
        <h1 class="fs-4 text">Camera Filter</h1>
      </div>
    </div>

    <div class="row">
      <div class="col md-12">
        <div class="card p-2">
          <div class="card-body">
            <form class="row g-3">
              <div class="col-sm-12 col-xl-6">
                <label for="plateNo" class="form-label">Camera</label>
                 <v-select 
                    @change="setSelected" 
                    placeholder="Select Camera" 
                    :get-option-label="(option) => {
                      return `${option.location} (Camera ID: ${option.camera_id})`
                    }" 
                    :reduce="cameras => cameras.id" 
                    :filterable="false" 
                    :options="cameras"
                    @search="onSearch" 
                    v-model="search.camera_id"
                  >
                </v-select>
              </div>
              <div class="col-sm-12 col-xl-2">
                <label for="date" class="form-label">Date</label>
                <flat-pickr
                    id="date"
                    v-model="search.date"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                ></flat-pickr>
              </div>
              <div class="col-sm-12 col-xl-2">
                <label for="timeFrom" class="form-label">From</label>
                <flat-pickr
                    id="timeFrom"
                    v-model="search.from"
                    :config="timePicker"
                    class="form-control flatpickr-input"
                ></flat-pickr>
              </div>
              <div class="col-xl-2">
                <label for="timeTo" class="form-label">To</label>
                <flat-pickr
                    id="timeTo"
                    v-model="search.to"
                    :config="timePicker"
                    class="form-control flatpickr-input"
                ></flat-pickr>
              </div>
              <div class="col-auto d-flex justify-content-center">
                <button @click.prevent="clickSearch" :disabled="!search.camera_id" class="btn btn-info waves-effect waves-light align-self-end mr-2" type="button">
                  <i class="bx bx-search-alt-2 label-icon align-middle fs-16 me-2"></i>
                  Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <b-overlay :show="loading">
          <div class="card">
            <div class="card-header align-items-center d-flex">
              <div class="flex-grow-1 oveflow-hidden">
                <h4 class="text-muted text-truncates mb-0">
                  Search Result
                </h4>
            </div>
            </div>
              <div class="card-body">
                <div v-if="!isSearch" class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h4 class="mt-4 fw-semibold">Camera Filter</h4>
                      <p class="text-muted mt-3 fs-5"> 
                        Select Camera and Date to get record
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid" width="400">
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                    
                    <div class="row" v-if="filters.length">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body overflow-auto">
                              <div class="row justify-content-md-center">
                                <div class="col-12 col-md-12">
                                  <div class="row justify-content-md-center">
                                    <div class="col-12 col-md-6 col-lg-5 col-xl-6">
                                      <v-select
                                        @change="selectRejectReason"
                                        :options="reject_reason_list"
                                        placeholder="Select Reject Reason" 
                                        :get-option-label="(option) => {
                                          return `${option.name}`
                                        }" 
                                        :value="reject_reason_list"
                                        :reduce="reject_reason_list => reject_reason_list.id" 
                                        append-to-body
                                        v-model="selected_reject_reason"
                                      />
                                      <input v-if="selected_reject_reason && selected_reject_reason == 7" v-model="other_reject_reason" type="text" class="form-control mt-1" placeholder="Enter Other Reason">
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 mt-md-0 mt-2">
                                      <button @click.prevent="reject" type="button" class="mr-2 w-100 btn btn-danger">Reject</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  <div class="col-12">
                    <data-table
                      :rows="filters"
                      striped
                      :loading="loading"
                      hoverable
                      @loadData="clickSearch"
                    >

                      <template #thead>
                          <table-head @click="toggleAll()">
                            <template v-if="filters.length && traffic_record_ids.length == filters.length">
                              <input type="checkbox" checked> 
                            </template>
                            <template v-else>
                              <input type="checkbox"> 
                            </template>
                          </table-head>
                          <table-head>File #</table-head>
                          <table-head>Violation Date</table-head>
                          <table-head>Violation Time</table-head>
                          <table-head>Camera ID</table-head>
                          <table-head>Location</table-head>
                      </template>

                      <template #tbody="{row}">
                          <table-body @click="toggleSelect(row.id)">
                            <template v-if="traffic_record_ids.includes(row.id)">
                              <input type="checkbox" :value="row.id" checked> 
                            </template>
                            <template v-else>
                              <input type="checkbox" :value="row.id"> 
                            </template>
                          </table-body>
                          <table-body>
                            <template v-if="row && row.filename">
                              <div @click="getCameraFilterDetails(row.id)" class="text-info" data-bs-toggle="modal" data-bs-target="#cameraFilterDetailsModal">{{ row.filename }}</div>
                            </template>
                            <template v-else>
                              n/a
                            </template>
                          </table-body>
                          <table-body>{{ row && row.timestamp ? moment(row.timestamp).format('MMMM DD, YYYY') : 'n/a' }}</table-body>
                          <table-body>{{ row && row.timestamp ? moment(row.timestamp).format('hh:mm:ss A') : 'n/a' }}</table-body>
                          <table-body>{{ row && row.camera ? row.camera.camera_id || 'n/a' : 'n/a' }}</table-body>
                          <table-body>{{ row && row.camera ? row.camera.location || 'n/a' : 'n/a' }}</table-body>
                      </template>

                      <template #empty>
                      <TableBodyCell colspan="6">
                          No results found!
                      </TableBodyCell>
                    </template>
                  </data-table>
                  </div>  
                </div>
            </div><!-- end card-body -->
          </div>
        </b-overlay>
      </div>
    </div>
    <div id="cameraFilterDetailsModal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-labelledby="cameraFilterDetailsModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-xl modal-fullscreen-lg-down">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editRecordModalLabel">Camera Filter Details <span v-if="selectedCameraFilter">({{ selectedCameraFilter.traffic_record.filename }})</span></h5>
            <button type="button" @click="resetCameraFilterDetails" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <b-overlay :show="loading">
              <b-tabs v-model="cameraFilterModalTab" tag="ul" class="nav-success nav-tabs-custom pl-0" content-class="mt-3" v-if="selectedCameraFilter">
                <b-tab title="Media">
                  <div class="row" v-if="selectedCameraFilter.media.length">
                    <MediaViewer :medias="selectedCameraFilter.media" :traffic_record="selectedCameraFilter.media" />
                  </div>
                  <div class="row" v-else>
                    <h4>No media files found</h4>
                  </div>
                </b-tab>
                <b-tab title="Traffic Record" class="bg-light">
                  <div class="row gx-0">
                    <div class="col-md-12 col-lg-6">
                      <ViolationInformation :violation_information="selectedCameraFilter.traffic_record.violation_information" />
                      <Violations :violations="selectedCameraFilter.traffic_record.violations"/>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <LtoRecord :lto_record="selectedCameraFilter.traffic_record.lto_record" />
                    </div>
                  </div>
                </b-tab>
                <!-- <b-tab title="NOV">
                    <div class="row">
                      <div class="col-md-12 mb-1">
                        <NovViewer :nov="selectedCameraFilter.nov" />
                      </div>
                    </div>
                </b-tab> -->
                <!-- <b-tab title="OVR" class="bg-light">
                    <div class="row gx-0">
                      <div class="col-md-12 col-lg-6">
                        <Ovr :ovr="selectedCameraFilter.ovr.ovr" />
                      </div>
                      <div class="col-md-12 col-lg-6">
                        <Violations :violations="selectedCameraFilter.ovr.violations"/>
                      </div>
                        <div class="col-md-12">
                        <ViolationPenaltyMatrix :violation_penalty_matrix="selectedCameraFilter.ovr.violation_penalty_matrix"/>
                      </div>
                    </div>
                </b-tab>
                <b-tab title="Tracking" class="bg-light">
                    <Tracking :tracking="selectedCameraFilter.tracking" />
                </b-tab>
                <b-tab title="Payment">
                  <div class="row">
                    <div class="col-md-12">
                      <Payment :payment="selectedCameraFilter.payment" />
                    </div>
                    <div class="col-md-12">
                      <OrEditLogs />
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Apprehensions">
                   <div class="row">
                    <div class="col-md-12">
                      <Apprehension
                        company="Dermalog"
                        :apprehension="selectedCameraFilter.apprehension.dermalog" />
                    </div>
                    <div class="col-md-12">
                      <Apprehension
                        company="Stradcom"
                        :apprehension="selectedCameraFilter.apprehension.stradcom" />
                    </div>
                  </div>
                </b-tab> -->
                <b-tab title="Timeline" class="bg-light">
                  <div class="row">
                    <div v-if="selectedCameraFilter.timeline" class="col-md-12">
                        <Timeline :timeline="selectedCameraFilter.timeline"/>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-overlay>
          </div>
          <div class="modal-footer">
            <button type="button" @click="resetCameraFilterDetails" class="btn btn-danger" data-bs-dismiss="modal">
              <i class="mdi mdi-close mr-1 align-middle"></i>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
